import { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { getAllTable } from "../network/TableApi/tableApi";

interface IProps {
  type: "factInc" | "amountMins" | "amountCompound";
  desc: string;
}

const ChartOverall = (props: IProps) => {
  const [all, getAll] = useState<any>();

  useEffect(() => {
    getAllTable({}).then((r) => {
      getAll(r);
    });
  }, []);

  return (
    <div className="flex justify-center flex-col">
      <p>{props.desc}</p>
      <LineChart
        className="mb-8"
        width={800}
        height={400}
        data={all}
        margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
      >
        <Line type="monotone" dataKey={props.type} stroke="#8884d8" />
        <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
        <XAxis dataKey="CloseTime" />
        <YAxis />
        <Tooltip />
      </LineChart>
    </div>
  );
};

export default ChartOverall;
